
import React, { useState, useEffect, useRef } from 'react';
import { Button, Table, Form, InputGroup, Pagination } from 'react-bootstrap';
import { BiMessageSquareDetail } from "react-icons/bi";
import { AiOutlineFilePdf } from "react-icons/ai";
import config from "../../config/config";
import Loader from "../loader/Loader";
import axios from "axios";
import { toast } from "react-toastify";
import { getAuthToken } from "../../utils/token";
export default function AwaitingInspection() {
  const [loading, setLoading] = useState(false);
  const [awaitinginspection, setAwaitinginspection] = useState([]);
  const [files, setFiles] = useState({});
  const fileInputRefs = useRef({});
  /* ---------------- Pagination ---------------- */
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = awaitinginspection.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages = Math.ceil(awaitinginspection.length / itemsPerPage);

  const fetchAwaitinginspection = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(
        `${config.API}/inspection/awaitinginspection`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data?.success) {
        setAwaitinginspection(response.data.unit_completed || []);
        setCurrentPage(1);
      }
    } catch (err) {
      console.error("Error fetching awaiting inspection:", err.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAwaitinginspection();
  }, []);
  const handleFileChange = (id, e) => {
    if (e.target.files && e.target.files[0]) {
      setFiles((prev) => ({
        ...prev,
        [id]: e.target.files[0],
      }));
    }
  };
  const handleSubmit = async (id) => {
    const token = getAuthToken();
    if (!token) {
      toast.error("Authentication token missing!");
      return;
    }
    const file = files[id];
    if (!file) {
      toast.warn("Please select a PDF file");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await axios.post(
        `${config.API}/inspection/awaitinginspectionfile/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data?.success) {
        toast.success(response.data.message || "Submitted successfully");
        setFiles((prev) => ({ ...prev, [id]: null }));
        if (fileInputRefs.current[id]) {
          fileInputRefs.current[id].value = "";
        }
      } else {
        toast.error(response.data?.message || "Something went wrong");
      }
    } catch (err) {
      toast.error("Failed to submit request");
    }
  };
  return (
    <div className="container-fluid my-4">
      <div className="card shadow-sm">
        <div className="card-body">
          <Table responsive className="align-middle">
            <thead>
              <tr className="text-muted">
                <th>Product ID</th>
                <th>PO Number</th>
                <th>Product Name</th>
                <th>Quantity Required</th>
                <th>Quantity Produced</th>
                <th>Arrival Date</th>
                <th>Action</th>
              </tr>
            </thead>
            {loading ? (
              <tbody>
                <tr>
                  <td colSpan="6" className="text-center">
                    <Loader />
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                {currentData.length > 0 ? (
                  currentData.map((awaiting) => (
                    <tr key={awaiting.id}>
                      <td>{awaiting.product?.product_code}</td>
                      <td className="text-nowrap">
                        {awaiting?.purchase_order?.po_number}
                      </td>
                      <td>{awaiting?.product?.name}</td>
                      <td>{awaiting?.quantity_required}</td>
                      <td>{awaiting?.quantity_produced}</td>
                      <td className="text-nowrap">
                        {awaiting?.purchase_order?.delivery_date}
                      </td>
                      <td>
                        <InputGroup className="mb-2">
                          <Form.Control
                            type="file"
                            accept="application/pdf"
                            ref={(el) =>
                              (fileInputRefs.current[awaiting.id] = el)
                            }
                            onChange={(e) =>
                              handleFileChange(awaiting.id, e)
                            }
                          />
                          <AiOutlineFilePdf className="ms-2 mt-2 fs-4 text-danger" />
                        </InputGroup>
                        <Button
                          variant="primary"
                          size="sm"
                          onClick={() => handleSubmit(awaiting.id)}
                        >
                          <BiMessageSquareDetail /> Place Inspection Call
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center text-muted py-3">
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            )}
          </Table>
          {totalPages > 1 && (
            <div className="d-flex justify-content-end mt-3">
              <Pagination>
                <Pagination.Prev
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(currentPage - 1)}
                />
                {[...Array(totalPages)].map((_, index) => (
                  <Pagination.Item
                    key={index + 1}
                    active={index + 1 === currentPage}
                    onClick={() => setCurrentPage(index + 1)}
                  >
                    {index + 1}
                  </Pagination.Item>
                ))}
                <Pagination.Next
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage(currentPage + 1)}
                />
              </Pagination>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

